<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Badges
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }"><i class="fa fa-dashboard"></i> Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'badges-index'}">Badges</router-link>
        </li>
        <li class="active">
          <span v-if="isCreate">Create</span>
          <span v-else>Edit</span>
        </li>
      </ol>
    </section>
    
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">{{ title }}</h3>
            </div>

            <form class="form-horizontal" @submit.prevent="submit">
              <div class="box-body" style="overflow: unset;">
                <div v-if="error" class="alert alert-danger">
                  <a class="close"
                    @click="error = false">
                    &times;
                  </a>
                  {{ error }}
                </div>

                <div class="form-group">
                  <label for="start_date"
                    class="col-sm-2 control-label">
                    Start Date <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <datepicker
                      id="start_date"
                      wrapper-class="custom-vdp"
                      input-class="form-control"
                      :disabled="disabledStartDate"
                      :clear-button="true"
                      @cleared="handleClearDate"
                      v-model="form.start_date">
                    </datepicker>
                  </div>
                </div>

                <div class="form-group">
                  <label for="end_date"
                    class="col-sm-2 control-label">
                    End Date <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <datepicker
                      id="end_date"
                      wrapper-class="custom-vdp"
                      input-class="form-control"
                      :disabled="disabledEndDate"
                      :clear-button="true"
                      v-model="form.end_date">
                    </datepicker>
                  </div>
                </div>

                <div class="form-group">
                  <label for="status"
                    class="col-sm-2 control-label">
                    Status <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <select
                      placeholder="Select Status"
                      class="form-control"
                      id="status"
                      v-model="form.status">
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="days" 
                    class="col-sm-2 control-label">
                    Days
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <span class="btn btn-default btn-xs margin-all"
                      @click="toggleAllDays">
                      All Days
                    </span>
                    <label 
                      class="checkbox-inline" 
                      v-for="item in days" 
                      :for="item.value"
                      :key='item.value'>
                      <input
                        type="checkbox"
                        :id="item.value"
                        :value="item.value"
                        v-model="form.days"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Badge Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="name"
                      placeholder="Name"
                      v-model="form.name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="type"
                    class="col-sm-2 control-label">
                    Badge Type <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <select
                      placeholder="Select Badge Type"
                      class="form-control"
                      id="type"
                      v-model="form.type">
                      <option value="default_badge">Default Badge</option>
                      <option value="top_badge">Top Hover Badge</option>
                      <option value="bottom_badge">Bottom Hover Badge</option>
                    </select>
                  </div>
                </div>

                <div v-if="form.type === 'default_badge'" class="form-group type-badge">
                  <label for="image"
                    class="col-sm-2 control-label-type">
                    Image <span class="req">*</span>
                  </label>

                  <div class="col-sm-8">
                    <button class="btn btn-sm btn-secondary"
                      @click.prevent="showModal('gallery')">
                      Choose File
                    </button>
                    <div class="upload-attention">
                      <h4>Upload Attention</h4>
                      <p>
                        Allowed   extension only for PNG file with max size 1024KB and minimum-maximum   dimension width 32px and height 32px
                        Info: Best uploaded image ratio is 1:1
                      </p>
                    </div>
                    <img v-if="form.image.url"
                      class="img-thumbnail img-responsive"
                      alt="Destination Image"
                      :src="parseImage(form.image.url, '_thumb')">

                    <img v-else
                      class="img-thumbnail img-responsive"
                      src="/static/img/img_placeholder.png"
                      alt="No image">
                  </div>
                </div>

                <div v-if="form.type === 'top_badge'" class="form-group type-badge">
                  <label for="image"
                    class="col-sm-2 control-label">
                    Icon Badges <span class="req"></span>
                  </label>

                  <div class="col-sm-10">
                    <button class="btn btn-sm btn-secondary"
                      @click.prevent="showModal('gallery')">
                      Choose File
                    </button>
                    <div class="upload-attention">
                      <h4>Upload Attention</h4>
                      <p>
                        Allowed   extension only for PNG file with max size 1024KB and minimum-maximum   dimension width 32px and height 32px
                        Info: Best uploaded image ratio is 1:1                      </p>
                    </div>
                    <img v-if="form.image.url"
                      class="img-thumbnail img-responsive"
                      alt="Destination Image"
                      :src="parseImage(form.image.url, '_thumb')">

                    <img v-else
                      class="img-thumbnail img-responsive"
                      src="/static/img/img_placeholder.png"
                      alt="No image">
                  </div>

                  <div>
                    <label for="badge_title"
                      class="col-sm-2 control-label margin-top-10">
                      Title Badges <span class="req">*</span>
                    </label>

                    <div class="col-sm-10 margin-top-10">
                      <input type="text"
                        class="form-control"
                        id="badge_title"
                        placeholder="Badge Title"
                        maxlength="11"
                        v-model="form.badge_title">
                    </div>
                  </div>

                  <label for="preset_color_id" 
                    class="col-sm-2 control-label margin-top-10">
                    Preset Color
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-10 margin-top-10">
                    <label 
                      class="radio-inline"
                      style="margin-left: 10px" 
                      v-for="item in badgeColor" 
                      :for="`preset-${item.id}`"
                      :key='`preset-${item.id}`'>
                      <input
                        type="radio"
                        :id="`preset-${item.id}`"
                        :value="item.id"
                        v-model="form.preset_color_id"
                      />
                      <div class="preset-color" :style="`background-color: ${item.background_color}`">
                        <p :style="`color: ${item.text_color}`">{{item.name}}</p>
                      </div>
                    </label>
                  </div>

                  <div>
                    <label for="badge_description"
                      class="col-sm-2 control-label margin-top-10">
                      Description Badges <span class="req">*</span>
                    </label>

                    <div class="col-sm-10 margin-top-10">
                      <textarea
                        class="form-control"
                        id="badge_description"
                        placeholder="Badge Description"
                        maxlength="90"
                        v-model="form.badge_description">
                      </textarea>
                    </div>
                  </div>
                </div>

                <div v-if="form.type === 'bottom_badge'" class="form-group type-badge">
                  <label for="image"
                    class="col-sm-2 control-label">
                    Image <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <button class="btn btn-sm btn-secondary"
                      @click.prevent="showModal('gallery')">
                      Choose File
                    </button>
                    <div class="upload-attention">
                      <h4>Upload Attention</h4>
                      <p>
                      Allowed extension only for PNG   file with max size 5000KB and maximum width: 200px and maximum height 100px.
                        Info: Best uploaded image ratio is 2:1                      </p>
                    </div>
                    <img v-if="form.image.url"
                      class="img-thumbnail img-responsive"
                      alt="Destination Image"
                      :src="parseImage(form.image.url, '_thumb')">

                    <img v-else
                      class="img-thumbnail img-responsive"
                      src="/static/img/img_placeholder.png"
                      alt="No image">
                  </div>

                  <div>
                    <label for="badge_description"
                      class="col-sm-2 control-label margin-top-10">
                      Description Badges <span class="req">*</span>
                    </label>

                    <div class="col-sm-10 margin-top-10">
                      <textarea
                        class="form-control"
                        id="badge_description"
                        placeholder="Badge Description"
                        maxlength="90"
                        v-model="form.badge_description">
                      </textarea>
                    </div>
                  </div>
                </div>


                <transition name="slideDown">
                  <modal title="Select Badge Image"
                    v-if="show.gallery">
                    <FileGallery
                      type="category"
                      @update-images="setImage"
                      :selected="form.image" />
                  </modal>
                </transition>

                <div class="form-group">
                  <label for="destination" class="col-sm-2 control-label">
                    Destination
                  </label>

                  <div class="col-sm-10">
                    <treeselect
                      placeholder="Select Product Destination"
                      v-model="form.destinations"
                      :value-consists-of="'ALL_WITH_INDETERMINATE'"
                      sort-value-by="LEVEL"
                      id="destination"
                      ref="destinationOption"
                      :multiple="true"
                      :options="list.destinations"
                      :default-expand-level="2"
                      :auto-load-root-options="true">
                    </treeselect>
                  </div>
                </div>

                <div class="form-group">
                  <label for="category" 
                    class="col-sm-2 control-label">
                    Category
                  </label>

                  <div class="col-sm-10">
                    <v-select multiple
                      id="category"
                      name="category"
                      placeholder="Select Category"
                      v-model="form.categories"
                      :options="list.categories">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="source"
                    class="col-sm-2 control-label">
                    Source
                  </label>

                  <div class="col-sm-10">
                    <v-select multiple
                      id="source"
                      name="source"
                      placeholder="Select Source"
                      v-model="form.vendors"
                      :options="list.vendors">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="merchant"
                    class="col-sm-2 control-label">
                    Merchant
                  </label>

                  <div class="col-sm-10">
                    <v-select multiple
                      id="merchant"
                      name="merchant"
                      placeholder="Select Merchant"
                      v-model="form.merchants"
                      :options="list.merchants">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="products"
                    class="col-sm-2 control-label">
                    Products
                  </label>

                  <div class="col-sm-10">
                    <v-select multiple
                      id="products"
                      name="products"
                      placeholder="Select Products"
                      v-model="form.products"
                      :options="list.products">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="media" 
                    class="col-sm-2 control-label">
                    Media
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <label 
                      class="checkbox-inline" 
                      v-for="item in medias" 
                      :for="item.value"
                      :key='item.value'>
                      <input
                        type="checkbox"
                        :id="item.value"
                        :value="item.value"
                        v-model="form.medias"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>

              </div>

              <div class="box-footer">
                <button type="submit" class="btn btn-info pull-right" v-if="isCreate">Create</button>
                <button type="submit" class="btn btn-info pull-right" v-else>Update</button>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import FileGallery from '@/components/modules/common/FileGallery';
import Common from '@/mixins/Common';
import flatten from 'lodash/flatten';
import Modal from '@/components/modules/common/Modal';
import { Treeselect, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';

export default {
  name: 'BadgesForm',
  mixins: [Common],
  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    Datepicker,
    FileGallery,
    Modal,
    Treeselect,
  },
  watch: {
    /* eslint-disable */
    'form.start_date'() {
      if (this.form.start_date > this.form.end_date) {
        this.form.end_date = null;
      }
    },
  },
  computed: {
    disabledEndDate() {
      return {
        to: (this.form.start_date) ? moment(this.form.start_date).toDate() : moment().subtract(1, 'days').toDate(),
      };
    },
  },
  data() {
    return {
      disabledStartDate: { to: moment().subtract(1, 'days').toDate() },
      title: 'Add New Badges',
      error: null,
      form: {
        start_date: null,
        end_date: null,
        days: [],
        name: null,
        image: {
          id: null,
          url: null,
        },
        destinations: [],
        categories: [],
        vendors: [],
        merchants: [],
        products: [],
        medias: [],
        status: 'active',
        type: 'default_badge',
        badge_title: '',
        preset_color_id: null,
        badge_description: '',
      },
      badgeColor: [],
      show: {
        gallery: false,
      },
      days: [
        {
          label: 'Mon',
          value: 1,
        },
        {
          label: 'Tue',
          value: 2,
        },
        {
          label: 'Wed',
          value: 3,
        },
        {
          label: 'Thu',
          value: 4,
        },
        {
          label: 'Fri',
          value: 5,
        },
        {
          label: 'Sat',
          value: 6,
        },
        {
          label: 'Sun',
          value: 7,
        },
      ],
      list: {
        products: [],
        destinations: [],
        flatDestinations: [],
        categories: [],
        vendors: [],
        merchants: [],
      },
      params: {
        page: 1,
        perpage: 500,
      },
      medias: [
        {
          label: 'Desktop',
          value: 'desktop',
        },
        {
          label: 'Apps',
          value: 'apps',
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    handleClearDate() {
      this.disabledStartDate = { to: moment().subtract(1, 'days').toDate() };
    },
    async init() {
      if (!this.isCreate) {
        this.title = 'Edit Badges';
        this.fetch();
      }

      this.getBadgeColor();
      await this.fetchItem('categories');
      await this.fetchItem('vendors');
      await this.fetchItem('merchants');
      await this.fetchItem('products');
      await this.getAvailableDestination();
    },
    async fetch() {
      this.axios.get(`/badges/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;
          this.setFieldValue(data);
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },
    async getBadgeColor() {
      this.axios.get('/badge-color')
      .then((response) => {
        this.badgeColor = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
    },
    setFieldValue(data) {
      this.form.start_date = data.start_date;
      this.form.end_date = data.end_date;
      this.form.days = data.days.split(',').map(Number);
      this.form.name = data.name;
      this.form.image.id = data.image_id;
      this.form.image.url = data.image;
      this.form.badge_title = data.title;
      this.form.badge_description = data.description;
      this.form.preset_color_id = data.preset_color_id;
      this.form.type = data.type;
      if (data.destinations) {
        const valueDestinations = data.destinations
        .filter(l => !data.destinations.find(val => l.id === val.parent_id))
        .map(l => l.id);
        this.form.destinations = valueDestinations;
      }
      this.form.categories = data.categories ? this.getLabelValueItem(data.categories) : [];
      this.form.vendors = data.vendors ? this.getLabelValueItem(data.vendors) : [];
      this.form.merchants = data.merchants ? this.getLabelValueItem(data.merchants) : [];
      if (data.products) {
        this.form.products = this.getLabelValueItem(
          data.products.filter(product => 
          product.is_insert_manual),
        );
      }
      this.form.status = data.status;
      this.form.medias = data.medias.split(',');
    },
    getLabelValueItem(dataArray) {
      if (!dataArray) return [];

      const dataList = [];
      dataArray.map(data => dataList.push({
        value: data.id,
        label: data.name,
      }));
      return dataList;
    },
    async getAvailableDestination() {
      const destinations = await this.fetchItem('destinations');
      this.list.destinations = await this.generate(destinations);
      this.list.flatDestinations = await this.flattenDestination(destinations);
    },
    fetchItem(type) {
      return new Promise((resolve) => {
        let enpoint = type;
        if (type === 'products') {
          enpoint = 'products-only';
        }
        this.axios.get(`/${enpoint}`, { params: this.params })
          .then((response) => {
            const { data } = response.data;
            const results = data.map(item => ({ label: item.name, value: item.id }));
            this.list[type] = results;
            resolve(data);
          })
          .catch((error) => {
            console.log(`Fetch ${type} error`, error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: `Failed to fetch available ${type}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchItem(type);
                }
              });
            }
          });
      });
    },

    generate(data) {
      if (!data) return [];

      return data.map((local) => {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            isDefaultExpanded: true,
            children: local.child.map((parent) => {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  isDefaultExpanded: true,
                  children: parent.child.map((child) => {
                    if (child.child) {
                      return {
                        id: child.id,
                        label: child.name,
                        children: child.child.map(grandchild => ({
                          id: grandchild.id,
                          label: grandchild.name,
                        })),
                      };
                    }
                    return {
                      id: child.id,
                      label: child.name,
                    };
                  }),
                };
              }

              return {
                id: parent.id,
                label: parent.name,
              };
            }),
          };
        }

        return {
          id: local.id,
          label: local.name,
        };
      });
    },

    flattenDestination(data) {
      const result = [];

      data.forEach((parent) => {
        result.push({
          id: parent.id,
          label: parent.name,
        });

        if (parent.child !== null) {
          parent.child.forEach((child) => {
            result.push({
              id: child.id,
              label: child.name,
            });

            if (child.child) {
              child.child.forEach((grandchild) => {
                result.push({
                  id: grandchild.id,
                  label: grandchild.name,
                });
              });
            }
          });
        }
      });

      return flatten(result);
    },

    async loadOptions({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        if (this.destinationListUpdated) {
          await this.getAvailableDestination();
          this.destinationListUpdated = false;
        }
      }
    },
    toggleAllDays() {
      if (this.form.days.length < 1) {
        this.form.days = [1, 2, 3, 4, 5, 6, 7];
      } else {
        this.form.days = [];
      }
    },
    showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    setImage(payload) {
      this.form.image = payload.images;
    },
    validate() {
      if (!this.form.start_date) {
        this.$swal('Start Date required', 'Please select start date to continue', 'warning');
        return false;
      }

      if (!this.form.end_date) {
        this.$swal('End Date required', 'Please select end date to continue', 'warning');
        return false;
      }

      if (this.form.days.length < 1) {
        this.$swal('Days required', 'Please select days to continue', 'warning');
        return false;
      }

      if (!this.form.name) {
        this.$swal('Badge Name required', 'Please fill badge name to continue', 'warning');
        return false;
      }

      if (this.form.type === 'bottom_badge') {
        if (!this.form.badge_description) {
          this.$swal('Badge Description required', 'Please fill badge description to continue', 'warning');
          return false;
        }
      }

      if (this.form.type === 'top_badge') {
        if (!this.form.preset_color_id) {
          this.$swal('Badge Preset Color is required', 'Please fill badge preset color to continue', 'warning');
          return false;
        }
        if (!this.form.badge_description) {
          this.$swal('Badge Description required', 'Please fill badge description to continue', 'warning');
          return false;
        }
        if (!this.form.badge_title) {
          this.$swal('Badge Title required', 'Please fill badge title to continue', 'warning');
          return false;
        }
      }

      if (this.form.type !== 'top_badge') {
        if (!this.form.image.id || !this.form.image.url) {
          this.$swal('Image required', 'Please select image to continue', 'warning');
          return false;
        }
      }

      if (this.form.medias.length < 1) {
        this.$swal('Media required', 'Please select media to continue', 'warning');
        return false;
      }

      if (!this.form.status) {
        this.$swal('Status required', 'Please select status to continue', 'warning');
        return false;
      }

      return true;
    },
    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    generatePostData() {
      const destinationsData = (this.form.destinations != null ?
        this.form.destinations.map(item => +item) : +item);
      const categoriesData = (this.form.categories != null ?
        this.form.categories.map(item => (item.value)) : null);
      const vendorsData = (this.form.vendors != null ?
        this.form.vendors.map(item => (item.value)) : null);
      const merchantsData = (this.form.merchants != null ?
        this.form.merchants.map(item => (item.value)) : null);
      const productsData = (this.form.products != null ?
        this.form.products.map(item => (item.value)) : null);
      if (this.form.type === 'default_badge') {
        const data = {
          start_date: this.parseTime(this.form.start_date, 'YYYY-MM-DD'),
          end_date: this.parseTime(this.form.end_date, 'YYYY-MM-DD'),
          days: JSON.stringify(this.form.days),
          name: this.form.name,
          image: this.form.image.id,
          destinations: (destinationsData != null ? 
                        JSON.stringify(destinationsData) : 
                        destinationsData),
          categories: (categoriesData != null ? JSON.stringify(categoriesData) : categoriesData),
          vendors: (vendorsData != null ? JSON.stringify(vendorsData) : vendorsData),
          merchants: (merchantsData != null ? JSON.stringify(merchantsData) : merchantsData),
          products: (productsData != null ? JSON.stringify(productsData) : productsData),
          medias: this.form.medias.toString(),
          status: this.form.status,
          position: 'right',
          type: this.form.type,
        };
        return data;
      }
      if (this.form.type === 'bottom_badge') {
        const data = {
          start_date: this.parseTime(this.form.start_date, 'YYYY-MM-DD'),
          end_date: this.parseTime(this.form.end_date, 'YYYY-MM-DD'),
          days: JSON.stringify(this.form.days),
          name: this.form.name,
          image: this.form.image.id,
          destinations: (destinationsData != null ? 
                        JSON.stringify(destinationsData) : 
                        destinationsData),
          categories: (categoriesData != null ? JSON.stringify(categoriesData) : categoriesData),
          vendors: (vendorsData != null ? JSON.stringify(vendorsData) : vendorsData),
          merchants: (merchantsData != null ? JSON.stringify(merchantsData) : merchantsData),
          products: (productsData != null ? JSON.stringify(productsData) : productsData),
          medias: this.form.medias.toString(),
          status: this.form.status,
          position: 'right',
          type: this.form.type,
          description: this.form.badge_description,
        };
        return data;
      }
      if (this.form.type === 'top_badge') {
        const data = {
          start_date: this.parseTime(this.form.start_date, 'YYYY-MM-DD'),
          end_date: this.parseTime(this.form.end_date, 'YYYY-MM-DD'),
          days: JSON.stringify(this.form.days),
          name: this.form.name,
          image: this.form.image.id,
          destinations: (destinationsData != null ? 
                        JSON.stringify(destinationsData) : 
                        destinationsData),
          categories: (categoriesData != null ? JSON.stringify(categoriesData) : categoriesData),
          vendors: (vendorsData != null ? JSON.stringify(vendorsData) : vendorsData),
          merchants: (merchantsData != null ? JSON.stringify(merchantsData) : merchantsData),
          products: (productsData != null ? JSON.stringify(productsData) : productsData),
          medias: this.form.medias.toString(),
          status: this.form.status,
          position: 'right',
          type: this.form.type,
          description: this.form.badge_description,
          title: this.form.badge_title,
          preset_color_id: this.form.preset_color_id,
        };
        return data;
      }
      return null;
    },
    create() {
      const data = this.generatePostData();

      return this.axios.post('/badges', this.stringify(data))
        .then((response) => {
          this.badgeByBadge(response.data.data.id);
          this.$swal({
            title: 'Created',
            text: `${this.form.name} has been created.`,
            type: 'success',
            timer: 3000,
          });

          this.$router.go(-1);
        })
        .catch((error) => {
          console.log('error', error.response);

          if (error.response) {
            this.error = error.response.data.Message;
          }

          if (error) {
            let message = 'Failed to create new Badges';

            if (this.error) {
              message = this.error;
            }

            if (message.indexOf('Duplicate entry') >= 0) {
              message = 'Badges name alreay exist';
            }

            this.$swal({
              title: 'Create Failed!',
              text: message,
              type: 'warning',
              timer: 5000,
              onClose: () => {
                this.error = null;
              },
            });
          }
        });
    },
    update() {
      const data = this.generatePostData();

      return this.axios.put(`/badges/${this.$route.params.id}`, this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'Updated',
            text: `${this.form.name} has been updated.`,
            type: 'success',
            timer: 3000,
          });
          this.badgeByBadge(this.$route.params.id);
          this.$router.go(-1);
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            let message = 'Failed to update new Badges';

            if (this.error) {
              message = this.error;
            }

            this.$swal({
              title: 'Update Failed!',
              text: message,
              type: 'warning',
              timer: 5000,
              onClose: () => {
                this.error = null;
              },
            });
          }
        });
    },
    badgeByBadge(badgeId) {
      return new Promise(async (resolve, reject) => {
        try {
          await this.axios.put(`/badge-product/by-badge/${badgeId}`);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-all{
  margin-right: 7px;
  margin-top: 7px;
}
.control-label-type {
  text-align: left;
}
.type-badge {
  border: 1px solid black;
  padding: 10px 0px;
  margin-left: 13vw;
  margin-right: 0.2vw;
}
.upload-attention {
  border: 1px solid lightgray;
  padding: 10px;
  margin: 10px 0;
}
.preset-color {
  width: 320px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.margin-top-10 {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/badges/Form.vue